import Factory from '../factory';

const schema = Factory.schema('dynamic-pagination');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('title').setType(String);
attributes.prop('variant').setType(String);
attributes.prop('items').setType(Array);

export default schema;
